import { Component, OnInit, Input, ElementRef, HostListener, NgZone } from '@angular/core';
import {
	trigger,
	state,
	style,
	animate,
	transition
} from '@angular/animations';

import { GlobalService } from '../../../core/services/global.service';
import { MenuItem } from '../../models/menu-item.model';
import { Router } from '@angular/router';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss'],
	animations: [
		trigger('menuTrigger', [
			state('inactive', style({
				position: 'relative',
				height: '0',
				overflow: 'hidden',
				transition: 'height .35s ease'
			})),
			state('active', style({
				height: '100%',
				display: 'block'
			})),
			transition('inactive => active', animate('300ms ease-in')),
			transition('active => inactive', animate('300ms ease-out'))
		])
	]
})
export class SidebarComponent implements OnInit {

	@Input() options: any;
	@Input() items: Array<MenuItem>;

	active: boolean;
	menuItems: any;

	constructor(private globalService: GlobalService,
		           private router: Router,
		           private elementRef: ElementRef,
		           public zone: NgZone) {
	}

	ngOnInit(): void {
		this.globalService.sidebarActive$.subscribe(
			status => {
				this.active = status;
			});
	}

	closeAllSubmenus(): void {
		this.items.forEach(item => {
			item.show = false;
		});
	}

	@HostListener('document:click', ['$event'])
	private clickOutside(event): void {
		if (this.elementRef.nativeElement.contains(event.target)) {
		} else {
			this.closeAllSubmenus();
		}
	}

	routepath(path) {
		this.router.navigateByUrl(path);
	}

	closeSideNav() {
		this.closeAllSubmenus();
		this.globalService.closeSideBar();
	}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/shared/components/sidebar/sidebar.component.ts